<template>
    <div>
        <page-header
            :title="$t('pages.locker.my_coach.consulting.title')"
            :use-title-as-document-title="false"
        ></page-header>
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <p>{{ $t("pages.locker.my_coach.consulting.text") }}</p>

                        <router-link
                            class="btn btn-primary"
                            :to="{ name: 'locker.my-coach.contact' }"
                        >
                            {{ $t("pages.locker.my_coach.consulting.contact") }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <page-header
            :title="$t('pages.locker.my_coach.videos')"
            :use-title-as-document-title="false"
        ></page-header>
        <div v-if="!$store.getters.shouldLoadLocal">
            <div class="row">
                <div class="col-md-4 grid-margin" v-for="series in seriesList">
                    <series-card :series="series"></series-card>
                </div>
            </div>
            <div v-if="seriesList.length === 0" class="alert alert-secondary border-dark shadow-sm">
                {{ $t("pages.locker.my_coach.videos_empty") }}
            </div>

            <div class="mt-3">
                <pagination
                    :data="paginationData"
                    @pagination-change-page="getCoachSeries"
                ></pagination>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import VideoSeriesRepository from "../../../repositories/Gym/VideoSeriesRepository";
import SeriesCard from "../../Series/Includes/SeriesCard";

export default {
    name: "MyCoach",
    components: { PageHeader, SeriesCard },
    data: () => ({
        seriesList: [],
        paginationData: {}
    }),
    mounted() {
        this.getCoachSeries();
    },
    methods: {
        getCoachSeries() {
            VideoSeriesRepository.getMyCoachSeries().then(res => {
                this.seriesList = res.data.data;
                this.paginationData = res.data.meta;
            });
        }
    }
};
</script>

<style></style>
